import i18n from "./i18n";
import rtl from "jss-rtl";
import { create } from "jss";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { StylesProvider, jssPreset } from "@material-ui/core/styles";

// Styles
import "./assets/styles/index.scss";

// Components
import App from "./components/App";
import reportWebVitals from "./reportWebVitals";

// Providers
import { LanguageProvider } from "./contexts/languageContext";

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
	<I18nextProvider i18n={i18n}>
		<StylesProvider jss={jss}>
			<LanguageProvider>
				<App />
			</LanguageProvider>
		</StylesProvider>
	</I18nextProvider>,
);

reportWebVitals();
